import { useState } from 'react';
import { useIntl } from 'react-intl';

import { useSetAltBuildingState } from '../../../hooks/alt-building.hook';
import { AltBuilding } from '../../../store/alt-buildings/types';
import { ButtonContainer, CloseButton, SwitchBuildingButton } from './styles';
import { useSelector } from 'react-redux';
import { selectCurrentAltBuilding } from '../../../store/alt-buildings/selectors';
import { AltBuildingModalSelect } from '../alt-building-modal-select/component';

interface SwitchAltBuildingsModalProps {
  altBuildings: Array<AltBuilding>;
  onClose: VoidFunction;
}

export const AltBuildingModalBody = ({ altBuildings, onClose }: SwitchAltBuildingsModalProps): JSX.Element => {
  const intl = useIntl();
  const [selectedAltBuilding, setSelectedAltBuilding] = useState<AltBuilding>();
  const currentAltBuilding = useSelector(selectCurrentAltBuilding);
  const handleSwitchBuilding = useSetAltBuildingState(selectedAltBuilding, onClose);
  return (
    <>
      <AltBuildingModalSelect
        altBuildings={altBuildings}
        setSelectedAltBuilding={setSelectedAltBuilding}
        currentAltBuilding={currentAltBuilding}
        selectedAltBuilding={selectedAltBuilding}
      />
      <ButtonContainer>
        <SwitchBuildingButton
          onClick={handleSwitchBuilding}
          text={intl.formatMessage({ id: 'submit' })}
          disabled={!selectedAltBuilding}
          dataCy="submit-alt-building"
        />
        <CloseButton onClick={onClose} text={intl.formatMessage({ id: 'cancel' })} variant="closeButton" />
      </ButtonContainer>
    </>
  );
};
